const Form100TC = {
    stepName: {
        importantNotes: "重要事项",
        selectType: "选择类型",
        schoolInformation: "学校信息",
        applicantBodyInformation: "办学团体资料",
        eligibilityRequirement: "申请资格",
        locationPreference: "属意地点",
        documentUpload: "文档上传",
        successfulObligations: "成功的办学团体的责任",
        confirmation: "确认",
    },
    label: {
        year: "年份：",
        yearPage: "年份",
        type: "工作类型：",
        typeOptions: {
            A: "重置小学",
            B: "重置中学",
            C: "重置小学及中学",
            D: "营办一所特殊学校",
            E: "营办一所附设宿舍的特殊学校",
            F: "有时限性扩充小学／中学校舍",
            G: "营办全新有时限性小学／中学",
            H: "营办全新小学／中学",
            I: "小学／中学校舍扩充",
        },
        exercisePeriod: "工作期间：",
        to: "至：",
        no: "编号：",
        title: "表单标题：",
        districtTitle: "标题中的地区：",
        itemNo: "项目编号：",
        location: "地点：",
        locationItemNoAndLocation: "场地/场所编号和地点",
        addExercise: "添加工作",
        declaration: "本人已阅读「个人资料收集声明」及完全明白其内容。",
        exerciseType: "校舍分配工作种类",
        districtOrPlace: "校舍位置",
        noInPdfTitle: "SAE编号",
        copies: "一式份数",
        pages: "提交文件份数",
        noInEformTitle: "Eform标题中的编号",
        noOfPremisesAvailable: "可用的房舍数量：",
        pdfLink: "最新的义务PDF的链接：",
        schoolNameEn: "学校名称（英文）",
        schoolNameCn: "学校名称（中文）",
        schoolAddressEn: "学校地址（英文）",
        schoolAddressCn: "学校地址（中文）",
        financeType: "资助种类",
        applicantBodyEn: "办学团体的注册名称（英文）",
        applicantBodyCn: "办学团体的注册名称（中文）",
        correspondenceAddressEn: "通讯地址（英文）",
        correspondenceAddressCn: "通讯地址（中文）",
        titleEn: "称谓（英文）",
        titleCn: "称谓（中文）",
        contactNameEn: "联络人姓名（英文）",
        contactNameCn: "联络人姓名（中文）",
        positionEn: "职位（英文）",
        positionCn: "职位（中文）",
        telNo: "电话号码",
        faxNo: "传真号码",
        email: "电邮地址",
        contactPersonInformation: "联络人信息",
        isRegisteredOrdinance: "办学团体是否按《公司条例》(第622章)注册成立？",
        specifyOrdinance: "请注明办学团体是按哪条条例于香港注册成立",
        isExemptOrdinance:
            "办学团体是否根据《税务条例》(第112章)第88 条获得豁免缴税？",
        yesOrNo: {
            yes: "是",
            no: "否",
        },
        indicatePreference: "请于以下位置按次序表明属意地点–",
        locationSelectType: "种类",
        locationItemNo: "项目编号",
        locationLocation: "位置",
        locationPriority: "优先次序",
        documentsChecklist: "所需文件核对清单",
        allocatedCommitted: "如获分配校舍， 办学团体须承诺会：",
        allocatedCommittedNote: {
            a: "推行各项教育局推广的教育措施；",
            b: "交回现有校舍。如现有校舍座落于办学团体或该校或与办学团体／该校有关的第三者所拥有的私人土地上，办学团体须承诺会确保于获分配新校舍后，把现有学校的用地连同其上的所有建筑物及构筑物将在不受产权负担及任何申索、诉讼、法律程序及法律责任(无论是以逆权管有或以其他形式)影响和无须费用及补偿之下一并交回香港特区政府；及",
            c: "于政府指定时间内，就校舍的使用与政府签订租约，并签订服务合约，以供当局监控服务质素和确保相关教育政策得以遵行。",
        },
        allocatedCommittedCheckText:
            "我确认我已阅读、明白及同意遵从上述成功申请的办学团体的责任",
        EDBDeclaration: "教育局的声明",
        applicationNature: "申请及提交办学计划书属非约束性",
        EDBDeclarationText:
            "邀请有关团体提出申请及提交详细办学计划书一事属非约束性，既不会对任何一方构成有关校舍分配的任何形式的要约或作出任何形式的要约的依据，亦不会令政府负上任何法律义务；同时不会妨碍校舍分配委员会／政府日后进行的审查，亦不会迫使政府必须采取任何行动，包括批准或不批准任何校舍分配，不论已接获的申请数目多寡。这次邀请并不会迫使政府必须把校舍于任何时间内分配予任何有关方面。",
        responsiblePerson: "办学团体负责人",
        responsiblePersonNameEn: "办学团体负责人的姓名（英文）",
        responsiblePersonNameCn: "办学团体负责人的姓名（中文）",
        responsiblePersonPosition: "职位",
        responsiblePersonOrganisation: "机构",
        obligationLink: "查看最新的义务PDF的链接",
        titleEnOp: {
            Mr: "Mr",
            Mrs: "Mrs",
            Ms: "Ms",
            Miss: "Miss",
        },
        titleCnOp: {
            Mr: "先生",
            Mrs: "太太",
            Ms: "女士",
            Miss: "小姐",
        },
        financeTypeOp: {
            Aided: "资助",
            Caput: "按位津贴",
            Direct: "直接资助计划",
            Private: "私立",
            Others: "其他",
        },
        otherRemark: "请备注",
        eligibleSchoolType: "合资格申请学校类型",
        allocationType: "分配类型",
        allocationTypeOp: {
            Premises: "校舍",
            Site: "校址",
        },
        allocationNo: "校舍分配工作编号",
    },
    documentsChecklistMsg: {
        one: "1. <u>若办学团体按《公司条例》注册成立</u>，请提供办学团体的公司注册文件及其组织章程细则，并请填写本表格的",
        oneA: "附页I",
        oneB: "。",
        two: "2. <u>若办学团体按其条例注册成立</u>，请提供有关条例的内容，及其章程（如有）。",
        three: "3. 办学团体的免税证明书。",
        four: "4. 上载下列文件：",
        fourA: "(i) 办学计划书（连同所有附件不超过 {{pages}} 页",
        fourB: "）、(ii) 摘要（不超过两页",
        fourC: "）及(iii) 现时营办学校一览表（请列明学校名称、地址及所属类别）。",
        five: "5. 我明白我须向教育局提交一式{{copies}}份下列文件：",
        fiveA: "(i) 办学计划书（连同所有附件不超过 {{pages}} 页<sup>#</sup>）、(ii) 摘要（不超过两页<sup>#</sup>）及(iii) 现时营办学校一览表（请列明学校名称、地址及所属类别）。",
        six: "6. 现有校舍设施、状况及土地类别／楼宇性质、班级结构及入读人数调查表格（本表格的",
        sixA: "附页II",
        sixB: "）。",
        seven: "7. 班级结构及入读人数调查表格（本表格的",
        sevenA: "附页II",
        sevenB: "）。",
        eight: "8. 若现时校舍座落于办学团体或该校或与办学团体／该校有关的第三者所拥有的私人土地上，请提供业权详情及有关记录，包括但不限于业权契据、土地／租赁协议及有关的平面图、经土地注册处认证最近期的业权记录、令状、传票、押记令、由政府或其他主管机关发出之通告命令等（只适用于申请重置现有学校）。",
        nine: "9. 证明校方就重置／扩充计划（以适用者为准）已咨询家长及教师的有关文件及其对重置计划／扩充（以适用者为准）意见的资料。请提供有关咨询的规模／方式等资料，例如发出及收回的问卷数目等。",
    },
    tooltipMsg: {
        schoolInformation: "申请必须由申请重置的学校的注册办学团体提交。",
        applicantBodyInformation:
            "办学团体必须为注册办学团体， 并符合有关申请资格。",
        eligibilityRequirement: "请留意《填表须知》第一项有关申请资格的内容。",
        locationPriority:
            "请填写属意地点的优先次序，以「1」代表首选。办学团体可选择最多{{premisesAvailable}}间校舍， 而最少应选择1间校舍。所有申请均会由校舍分配委员会审核， 审核申请时，办学团体的选择次序会列作考虑因素。如没有填写任何优先次序，或所填写的资料不能清楚显示办学团体所拣选的优先次序，有关申请或不会受理。于是次校舍分配工作，政府并非必须把校舍分配予任何有关方面，或按办学团体属意地点的优先次序而作分配。",
        documentsChecklist: "载于超过页数限制的页面内容将不被考虑",
    },
    errorMsg: {
        repeatData: "请输入不重复的{{item}}",
    },
    expiredMessage:
        "现时并没有可供申请的校舍分配工作。有关校舍分配工作的最新消息，请参阅本局网页：",
    tips: {
        note: "填写本表格前请细阅《填表须知》。",
        noteTwo:
            "如办学团体希望申请多于一个校舍／校址（以适用者为准），请按「增加」。",
    },
};

export default Form100TC;
